<template>
    <div class="page-content">
        <div id="disclaimer" class="section grow pt-5 pb-5 bg-eggshell">
            <div class="container h-100">
                <div class="d-flex h-100 text-left align-items-center">
                    <div class="w-100">
                        <termly-policy termlyDataId="98627c00-95ad-4281-9c40-e50c482cccc4"></termly-policy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'disclaimer',
  metaInfo: {
      title: 'Disclaimer'
  },
  components: {
  },
  mounted(){
  }
}
</script>
